<template>
  <div
    v-loading="childLoading"
    class="modeStyle-contain"
  >
    <!-- 创单抽成配置 -->
    <div style="height: 60vh; overflow-y: auto">
      <p style="color: red;">如果起始订单金额大于0,0-起始订单金额之间订单不抽成</p>
      <!-- 配置-抽成配置-司机抽成-模式二和创单抽成配置 -->
      <div class="second-main-wrap">
        <!-- 标题前小方块 + 标题 + 生效中/空闲中按钮  -->

        <!-- 全职司机 -->
        <div class="mode_submit-data">
          <div class="mode-head">
            <!-- 标题前小方块 -->
            <div class="title-square"></div>
            <!-- 标题 -->
            <span style="display: inline-block">全职司机抽成（默认）</span>
          </div>
          <div style="margin-top: 20px">
            自定义金额

            <el-button
              @click="addContent('full')"
              type="success"
              style="margin-left: 20px;"
              class="btnSelect"
              icon="el-icon-plus"
            ></el-button>
          </div>
          <div
            v-for="(item,index) in fullData.step_conf"
            :key="index"
            class="box-content"
          >
            <div style="display: flex; justify-content: flex-end">
              <el-button
                type="danger"
                @click="delData(index, 'full')"
                icon="el-icon-close"
              ></el-button>
            </div>
            <div class="disTitle">
              <span class="span-mode">订单金额大于</span>
              <div>
                <el-input
                  v-model="item.base_amount"
                  class="input-item1 input-item-active"
                  placeholder="订单金额大于"
                >
                </el-input>
                元
              </div>
            </div>
            <div class="disTitle">
              <span class="span-mode">固定金额抽成</span>
              <div>
                <el-input
                  v-model="item.fee_money"
                  class="input-item1 input-item-active"
                  placeholder="固定金额抽成"
                >
                </el-input>
                元
              </div>
            </div>
            <div class="disTitle">
              <span class="span-mode">百分比金额抽成</span>
              <div>
                <el-input
                  v-model="item.fee_rate"
                  class="input-item1 input-item-active"
                  placeholder="订单金额百分比抽成"
                >
                </el-input>
                %
              </div>
            </div>
          </div>

          <el-button
            class="btn1"
            type="info"
            @click="selectTimeChangeQ"
          >自定义时间段抽成</el-button>
          <div v-if="selectTimeQ_children == true">
            <div>
              <div class="btnTitle">
                <span class="title-a">抽成生效时间段:</span>
                <el-button
                  @click="addContent('qz')"
                  type="success"
                  class="btnSelect"
                  icon="el-icon-plus"
                ></el-button>
              </div>

              <div
                v-for="(item, index) in fullData.synchronization"
                :key="index"
                class="box-content"
              >
                <div style="display: flex; justify-content: flex-end">
                  <el-button
                    type="danger"
                    @click="delData(index, 'qz')"
                    icon="el-icon-close"
                  ></el-button>
                </div>

                <div>

                  <div
                    style="border-bottom: 1px solid #606266;padding-bottom: 10px;"
                    v-for="(item2,index2) in item.step_conf"
                    :key="index2"
                  >
                    <div class="disTitle">
                      <span class="span-mode">订单金额大于</span>
                      <div>
                        <el-input
                          v-model="item2.base_amount"
                          class="input-item1 input-item-active"
                          placeholder="订单金额大于"
                        >
                        </el-input>
                        元
                      </div>
                    </div>
                    <div class="disTitle">
                      <span class="span-mode">固定金额抽成</span>
                      <div>
                        <el-input
                          v-model="item2.fee_money"
                          class="input-item1 input-item-active"
                          placeholder="固定金额抽成"
                        >
                        </el-input>
                        元
                      </div>
                    </div>
                    <div class="disTitle">
                      <span class="span-mode">百分比金额抽成</span>
                      <div>
                        <el-input
                          v-model="item2.fee_rate"
                          class="input-item1 input-item-active"
                          placeholder="订单金额百分比抽成"
                        >
                        </el-input>
                        %
                      </div>
                    </div>
                    <el-button
                      style="margin: 10px auto;display: block;"
                      type="danger"
                      @click="delData(index2, 'fullSync',index)"
                      icon="el-icon-close"
                    ></el-button>
                  </div>
                  <el-button
                    @click="addContent('fullSync',index)"
                    type="success"
                    class="btnSelect"
                    style="margin: 10px auto;display: block;"
                    icon="el-icon-plus"
                  ></el-button>
                  <!-- 选择时间 -->
                  <div class="disTitle">
                    <span class="span-mode">抽成生效时间：</span>
                    <div>
                      <el-time-picker
                        v-model="item.time_start"
                        :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                        placeholder="抽成生效时间"
                        value-format="HHmm"
                        format="HH:mm"
                        class="timeX"
                      >
                      </el-time-picker>
                    </div>
                  </div>
                  <div class="disTitle">
                    <span class="span-mode">抽成结束时间：</span>
                    <div>
                      <el-time-picker
                        v-model="item.time_end"
                        :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                        placeholder="抽成结束时间"
                        value-format="HHmm"
                        format="HH:mm"
                        class="timeX"
                      >
                      </el-time-picker>
                    </div>
                  </div>
                  <div class="modeStyle">
                    <el-button
                      class="edit-btn"
                      @click="editModeBtn('full', index, checkboxChangeQ(index))"
                      type="primary"
                    >编辑</el-button>
                    <!-- {{ allModeArr_children.length 全职sync}} -->
                    <div>
                      <span class="span-mode">订单模式：</span>
                      <!-- {{ checkboxChangeQ(index).length }}--{{ allModeArr_children.length }} -->
                      <!-- {{ full_synchronization_children[index].full_order_mode_code_array.length }}--{{
                                                allModeArr_children.length
                                            }} -->
                      <!-- <div v-if="full_synchronization_children[index].full_order_mode_code_array.length == allModeArr_children.length">
                                                <el-tag type="info">全部</el-tag>
                                            </div> -->
                      <!-- {{ item.full_order_mode_code_array }} -->

                      <div v-if="checkboxChangeQ(index).length == allModeArr_children.length">
                        <el-tag type="info">全部</el-tag>
                      </div>

                      <div>
                        <el-checkbox-group
                          v-model="item.order_mode_code_array"
                          disabled
                        >
                          <el-checkbox
                            v-for="(item, index1) in checkboxChangeQ(index)"
                            :label="item.order_mode.order_mode_code"
                            :key="index1"
                          >
                            {{ item.name }}
                          </el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- 兼职司机 -->
        <div class="mode_submit-data">
          <div class="mode-head">
            <!-- 标题前小方块 -->
            <div class="title-square"></div>
            <!-- 标题 -->
            <span style="display: inline-block">兼职司机抽成（默认）</span>
          </div>
          <div style="margin-top: 20px">
            自定义金额

            <el-button
              @click="addContent('part')"
              type="success"
              style="margin-left: 20px;"
              class="btnSelect"
              icon="el-icon-plus"
            ></el-button>
          </div>

          <div
            v-for="(item,index) in partData.step_conf"
            :key="index"
            class="box-content"
          >
            <div style="display: flex; justify-content: flex-end">
              <el-button
                type="danger"
                @click="delData(index, 'part')"
                icon="el-icon-close"
              ></el-button>
            </div>
            <div class="disTitle">
              <span class="span-mode">订单金额大于</span>
              <div>
                <el-input
                  v-model="item.base_amount"
                  class="input-item1 input-item-active"
                  placeholder="订单金额大于"
                >
                </el-input>
                元
              </div>
            </div>
            <div class="disTitle">
              <span class="span-mode">固定金额抽成</span>
              <div>
                <el-input
                  v-model="item.fee_money"
                  class="input-item1 input-item-active"
                  placeholder="固定金额抽成"
                >
                </el-input>
                元
              </div>
            </div>
            <div class="disTitle">
              <span class="span-mode">百分比金额抽成</span>
              <div>
                <el-input
                  v-model="item.fee_rate"
                  class="input-item1 input-item-active"
                  placeholder="订单金额百分比抽成"
                >
                </el-input>
                %
              </div>
            </div>
          </div>
          <el-button
            class="btn1"
            type="info"
            @click="selectTimeChangeJ"
          >自定义时间段抽成</el-button>
          <div v-if="selectTimeJ_children == true">
            <div>
              <div class="btnTitle">
                <span class="title-a">抽成生效时间段:</span>
                <el-button
                  @click="addContent('jz')"
                  type="success"
                  class="btnSelect"
                  icon="el-icon-plus"
                ></el-button>
              </div>

              <div
                v-for="(item, index) in partData.synchronization"
                :key="index"
                class="box-content"
              >
                <div style="display: flex; justify-content: flex-end">
                  <el-button
                    type="danger"
                    @click="delData(index, 'jz')"
                    icon="el-icon-close"
                  ></el-button>
                </div>
                <div>
                  <div
                    style="border-bottom: 1px solid #606266;padding-bottom: 10px;"
                    v-for="(item2,index2) in item.step_conf"
                    :key="index2"
                  >
                    <div class="disTitle">
                      <span class="span-mode">订单金额大于</span>
                      <div>
                        <el-input
                          v-model="item2.base_amount"
                          class="input-item1 input-item-active"
                          placeholder="订单金额大于"
                        >
                        </el-input>
                        元
                      </div>
                    </div>
                    <div class="disTitle">
                      <span class="span-mode">固定金额抽成</span>
                      <div>
                        <el-input
                          v-model="item2.fee_money"
                          class="input-item1 input-item-active"
                          placeholder="固定金额抽成"
                        >
                        </el-input>
                        元
                      </div>
                    </div>
                    <div class="disTitle">
                      <span class="span-mode">百分比金额抽成</span>
                      <div>
                        <el-input
                          v-model="item2.fee_rate"
                          class="input-item1 input-item-active"
                          placeholder="订单金额百分比抽成"
                        >
                        </el-input>
                        %
                      </div>
                    </div>
                    <el-button
                      style="margin: 10px auto;display: block;"
                      type="danger"
                      @click="delData(index2, 'partSync',index)"
                      icon="el-icon-close"
                    ></el-button>

                  </div>
                  <el-button
                    @click="addContent('partSync',index)"
                    type="success"
                    class="btnSelect"
                    style="margin: 10px auto;display: block;"
                    icon="el-icon-plus"
                  ></el-button>
                  <!-- 选择时间 -->
                  <div class="disTitle">
                    <span class="span-mode">抽成生效时间：</span>
                    <div>
                      <el-time-picker
                        v-model="item.time_start"
                        :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                        placeholder="抽成生效时间"
                        value-format="HHmm"
                        format="HH:mm"
                        class="timeX"
                      >
                      </el-time-picker>
                    </div>
                  </div>

                  <div class="disTitle">
                    <span class="span-mode">抽成结束时间：</span>
                    <div>
                      <el-time-picker
                        v-model="item.time_end"
                        :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                        placeholder="抽成结束时间"
                        value-format="HHmm"
                        format="HH:mm"
                        class="timeX"
                      >
                      </el-time-picker>
                    </div>
                  </div>
                  <div class="modeStyle">
                    <el-button
                      class="edit-btn"
                      @click="editModeBtn('part', index, checkboxChangeJ(index))"
                      type="primary"
                    >编辑</el-button>

                    <div>
                      <span class="span-mode">订单模式：</span>
                      <div v-if="checkboxChangeJ(index).length == allModeArr_children.length">
                        <el-tag type="info">全部</el-tag>
                      </div>
                      <div v-else>
                        <el-checkbox-group
                          v-model="item.order_mode_code_array"
                          disabled
                        >
                          <el-checkbox
                            v-for="(item, index1) in checkboxChangeJ(index)"
                            :label="item.order_mode.order_mode_code"
                            :key="index1"
                          >
                            {{ item.name }}
                          </el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>

        <!-- 按单司机 -->
        <div class="mode_submit-data">
          <div class="mode-head">
            <!-- 标题前小方块 -->
            <div class="title-square"></div>
            <!-- 标题 -->
            <span style="display: inline-block">按单司机抽成（默认）</span>
          </div>
          <div style="margin-top: 20px">
            自定义金额

            <el-button
              @click="addContent('single')"
              type="success"
              style="margin-left: 20px;"
              class="btnSelect"
              icon="el-icon-plus"
            ></el-button>
          </div>
          <div
            v-for="(item,index) in singleData.step_conf"
            :key="index"
            class="box-content"
          >
            <div style="display: flex; justify-content: flex-end">
              <el-button
                type="danger"
                @click="delData(index, 'single')"
                icon="el-icon-close"
              ></el-button>
            </div>
            <div class="disTitle">
              <span class="span-mode">订单金额大于</span>
              <div>
                <el-input
                  v-model="item.base_amount"
                  class="input-item1 input-item-active"
                  placeholder="订单金额大于"
                >
                </el-input>
                元
              </div>
            </div>
            <div class="disTitle">
              <span class="span-mode">固定金额抽成</span>
              <div>
                <el-input
                  v-model="item.fee_money"
                  class="input-item1 input-item-active"
                  placeholder="固定金额抽成"
                >
                </el-input>
                元
              </div>
            </div>
            <div class="disTitle">
              <span class="span-mode">百分比金额抽成</span>
              <div>
                <el-input
                  v-model="item.fee_rate"
                  class="input-item1 input-item-active"
                  placeholder="订单金额百分比抽成"
                >
                </el-input>
                %
              </div>
            </div>
          </div>

          <el-button
            class="btn1"
            type="info"
            @click="selectTimeChangeD"
          >自定义时间段抽成</el-button>
          <div v-if="selectTimeD_children == true">
            <div>
              <div class="btnTitle">
                <span class="title-a">抽成生效时间段:</span>
                <el-button
                  @click="addContent('ad')"
                  type="success"
                  class="btnSelect"
                  icon="el-icon-plus"
                ></el-button>
              </div>

              <div
                v-for="(item, index) in singleData.synchronization"
                :key="index"
                class="box-content"
              >
                <div style="display: flex; justify-content: flex-end">
                  <el-button
                    type="danger"
                    @click="delData(index, 'ad')"
                    icon="el-icon-close"
                  ></el-button>
                </div>
                <div>
                  <div
                    style="border-bottom: 1px solid #606266;padding-bottom: 10px;"
                    v-for="(item2,index2) in item.step_conf"
                    :key="index2"
                  >

                    <div class="disTitle">
                      <span class="span-mode">订单金额大于</span>
                      <div>
                        <el-input
                          v-model="item2.base_amount"
                          class="input-item1 input-item-active"
                          placeholder="订单金额大于"
                        >
                        </el-input>
                        元
                      </div>
                    </div>
                    <div class="disTitle">
                      <span class="span-mode">固定金额抽成</span>
                      <div>
                        <el-input
                          v-model="item2.fee_money"
                          class="input-item1 input-item-active"
                          placeholder="固定金额抽成"
                        >
                        </el-input>
                        元
                      </div>
                    </div>
                    <div class="disTitle">
                      <span class="span-mode">百分比金额抽成</span>
                      <div>
                        <el-input
                          v-model="item2.fee_rate"
                          class="input-item1 input-item-active"
                          placeholder="订单金额百分比抽成"
                        >
                        </el-input>
                        %
                      </div>
                    </div>
                    <el-button
                      style="margin: 10px auto;display: block;"
                      type="danger"
                      @click="delData(index2, 'singleSync',index)"
                      icon="el-icon-close"
                    ></el-button>
                  </div>
                  <el-button
                    @click="addContent('singleSync',index)"
                    type="success"
                    class="btnSelect"
                    style="margin: 10px auto;display: block;"
                    icon="el-icon-plus"
                  ></el-button>
                  <!-- 选择时间 -->
                  <div class="disTitle">
                    <span class="span-mode">抽成生效时间：</span>
                    <div>
                      <el-time-picker
                        v-model="item.time_start"
                        :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                        placeholder="抽成生效时间"
                        value-format="HHmm"
                        format="HH:mm"
                        class="timeX"
                      >
                      </el-time-picker>
                    </div>
                  </div>
                  <div class="disTitle">
                    <span class="span-mode">抽成结束时间：</span>
                    <div>
                      <el-time-picker
                        v-model="item.time_end"
                        :picker-options="{ selectableRange: '00:00:00 - 23:59:59' }"
                        placeholder="抽成结束时间"
                        value-format="HHmm"
                        format="HH:mm"
                        class="timeX"
                      >
                      </el-time-picker>
                    </div>
                  </div>
                  <div class="modeStyle">
                    <el-button
                      class="edit-btn"
                      @click="editModeBtn('single', index, checkboxChangeD(index))"
                      type="primary"
                    >编辑</el-button>

                    <div>
                      <span class="span-mode">订单模式：</span>
                      <div v-if="checkboxChangeD(index).length == allModeArr_children.length">
                        <el-tag type="info">全部</el-tag>
                      </div>
                      <div v-else>
                        <el-checkbox-group
                          v-model="item.order_mode_code_array"
                          disabled
                        >
                          <el-checkbox
                            v-for="(item, index1) in checkboxChangeD(index)"
                            :label="item.order_mode.order_mode_code"
                            :key="index1"
                          >
                            {{ item.name }}
                          </el-checkbox>
                        </el-checkbox-group>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- {{ activeName }} -->

    <!-- 保存按钮 如果当前模式是生效中则不展示保存按钮，空闲中的才展示保存按钮-->
    <div>
      <el-button
        class="sava-btn"
        :disabled="saveLoading"
        v-loading="saveLoading"
        @click="onSubmitDig()"
        type="primary"
      >{{
                saveLoading == true ? '保存数据中...' : '保存并使用'
            }}</el-button>
    </div>

    <!-- 编辑指定订单模式组件 -->
    <editMode
      :isShow="editMode_show_children"
      :data="checkedModes_children"
      :changeIndex_children="changeIndex_children"
      :checkboxSelect_children="checkboxSelect_children"
    ></editMode>
  </div>
</template>
<script>
var _this;
import editMode from './editMode.vue';
import bus from '@/components/common/bus';

export default {
    props: {
        isShow: Boolean,
        activeName: '', // 父组件传过来的tab激活 用来判断保存按钮是模式二还是模式三的
        childrenData: {} // 父组件传过来的详情接口返回数据
    },

    components: {
        editMode
    },
    data() {
        return {
            childLoading: false,
            modeCodeArray: [],
            saveLoading: false, // 保存数据loading_children
            changeIndex_children: '', // 订单模式编辑按钮点击的index
            checkboxSelect_children: '', // 编辑订单模式共用一个组件，用于区分全职，兼职，按单

            checkedModes_children: [], // 订单模式复选框勾选数组

            // 获取订单模式查询条件
            mode_options_data_children: {
                page: 1,
                limit: 50,
                status: ''
            },
            modeAll_children: [], // 获取订单模式后 订单模式编码
            allModeArr_children: [], // 获取订单模式后 订单模式数组
            // isIndeterminate: true,
            editMode_show_children: false, // 编辑组件

            loading_children: true,



            selectTimeQ_children: false,
            selectTimeJ_children: false,
            selectTimeD_children: false,

            fullBtn: false,
            partBtn: false,
            singleBtn: false,
            // 全职司机数据
            fullData: {},
            // 兼职司机数据
            partData: {},
            // 按单司机数据
            singleData: {},

            // tab标签当前选中项
            activeName_children: '',
            modeChange_children: '', // 使用中状态判断
            driver_insurance_children: '', // 模式一 兼职司机v-model绑定值

            submit_url_children: '/paymode/editpayModeSub',
            // open_3_pay: {
            //     val: '',
            //     alias: ''
            // },

            // 表单数据
            submit_data_children: {
                full_step: '',
                part_step: '',
                single_step: '',
                full_synchronization: '',
                part_synchronization: '',
                single_synchronization: ''
            }


        };
    },
    async created() {
        _this = this;
        _this.childLoading = true;
        console.log('阶梯created');
        // _this.activeName_children = _this.activeName; // 父组件切换tab标签，子组件created不执行，拿到的activeName_children不对导致保存按钮传参不对
        // console.log(_this.activeName_children, '_this.activeName_children子组件created赋值tab激活标签');

        // await _this.orderModeList(); //获取订单模式

        // await _this.payModeList(); // 获取司机抽成配置
        // await _this.awaitPayMode(); // 获取创单抽成配置
        // 接口返回值后取消页面loading

        // 等待_this.orderModeList()，_this.payModeList()，_this.awaitPayMode()三个方法都执行完在执行_this.childLoading = false
        // 但是_this.orderModeList()方法里面有一个getMode()是递归，
        //有可能第一轮getMode()走完就算_this.orderModeList()走完了，就执行了_this.childLoading = false，实际上getMode()是递归,所以还在继续走
        // 所以_this.orderModeList()需要等待getMode()也走完才可以返回resolve
        //   console.log(this.activeName,'1111111111');
        if (this.activeName == 4) {
            // 模式二或者创单抽成配置的时候加loading,模式一的时候不走下面方法
            // console.log(this.activeName,'1111111111');
            Promise.all([_this.orderModeList(), _this.payModeList()]).then((res) => {
                // console.log('promise');
                // 订单模式数量和接口返回的订单模式数量确定后才能计算出是否显示全部

                _this.childLoading = false;
                // console.log(_this.childLoading,'_this.childLoading');
            });
        }
    },
    computed: {
        // 显示选择的订单模式
        checkboxChangeQ() {
            return (index) => {
                let returnArray = [];
                // console.log(_this.full_synchronization_children[index].full_order_mode_code_array,'111接口返回的订单模式编码');
                // console.log(_this.allModeArr_children.length,'222订单模式接口返回的全部订单模式');

                // 已选择
                _this.fullData.synchronization[index].order_mode_code_array.forEach((e) => {
                    // 全部 遍历订单模式数组
                    _this.allModeArr_children.forEach((j) => {
                        // 在allModeArr_children中查找full_synchronization_children中的code
                        if (e == j.order_mode.order_mode_code) {
                            returnArray.push(j);
                        }
                    });
                });

                // 司机抽成选择的订单模式比如aaa，被删除了，但是详情接口需要把之前设置的订单模式aaa也返回
                // 全职司机订单模式是否显示全部，是根据接口返回的订单模式数据与order/orderModeLists返回的接口数量对比，如果相等就显示全部
                // 但是被删除的也返回，导致返回的接口大于order/orderModeLists返回的接口，而且点击订单模式的编辑按钮进入的订单模式编辑页面全选状态也不对
                // 解决方案就是把删除的订单模式过滤掉，然后点击编辑的时候把过滤后的订单模式编码传给订单模式编辑组件
                // _this.modeCodeArray = returnArray;
                // console.log(_this.modeCodeArray,'returnArray333'); // 如果不打印，_this.modeCodeArray没被用，就没事，但是这行打印导致就报错
                //因为_this.modeCodeArray被赋值导致数据改变，触发计算属性执行，一执行_this.modeCodeArray又改变，然后在执行，无限循环了
                //不要在计算属性内部修改数据：计算属性的“getter”函数应该只返回计算的值，而不应该在内部修改依赖的数据。这样会导致无限循环更新

                return returnArray;
            };
        },
        checkboxChangeJ() {
            // return (index) => {} 因为计算属性不能传参，但是箭头函数可以传参，所以用这种写法，这种写法就是为了传参的
            // 计算属性的触发条件是 值改变时触发，值不改变的时候就取缓存的值，跟方法相比比较节约性能
            return (index) => {
                let returnArray = [];

                // 已选择
                _this.partData.synchronization[index].order_mode_code_array.forEach((e) => {
                    // 全部
                    _this.allModeArr_children.forEach((j) => {
                        // 在allModeArr_children中查找part_synchronization_children中的code
                        if (e == j.order_mode.order_mode_code) {
                            returnArray.push(j);
                        }
                    });
                });

                return returnArray;
            };
        },
        checkboxChangeD() {
            return (index) => {
                let returnArray = [];

                // 已选择
                _this.singleData.synchronization[index].order_mode_code_array.forEach((e) => {
                    // 全部
                    _this.allModeArr_children.forEach((j) => {
                        // 在allModeArr_children中查找single_synchronization_children中的code
                        if (e == j.order_mode.order_mode_code) {
                            returnArray.push(j);
                        }
                    });
                });

                return returnArray;
            };
        }
    },

    methods: {
        // 订单模式编辑按钮
        editModeBtn(e, changeIndex_children, allArray) {
            // allArray是接口返回的订单模式，已经过滤到被删除的订单模式
            let allArrayStr = [];
            for (let index = 0; index < allArray.length; index++) {
                allArrayStr.push(allArray[index].order_mode.order_mode_code);
            }
            // console.log(allArrayStr, '--------');
            _this.checkedModes_children = allArrayStr;

            // e代表全职兼职按单 ，changeIndex_children代表点击的index
            _this.editMode_show_children = !_this.editMode_show_children;
            _this.changeIndex_children = changeIndex_children;
            if (e == 'full') {
                // _this.checkedModes_children = _this.full_synchronization_children[changeIndex_children].full_order_mode_code_array;// 导致删除的订单模式编码也存在
                _this.checkboxSelect_children = 'fullThird';
            } else if (e == 'part') {
                // _this.checkedModes_children = _this.part_synchronization_children[changeIndex_children].part_order_mode_code_array;
                _this.checkboxSelect_children = 'partThird';
            } else if (e == 'single') {
                // _this.checkedModes_children = _this.single_synchronization_children[changeIndex_children].single_order_mode_code_array;
                _this.checkboxSelect_children = 'singleThird';
            }
        },
        // 模式二详情
        payModeList() {
            // _this.childLoading = true;
            // console.log(_this.activeName_children,'子组件payModeList，_this.activeName_children');
            return new Promise((resolve) => {
                _this
                    .$post('/paymode/payModeThird')
                    .then((res) => {
                        // 兼职司机
                        this.partData = res.data[0];
                        this.partData.step_conf = JSON.parse(res.data[0].step_conf);
                        this.partData.synchronization = JSON.parse(res.data[0].synchronization);
                        this.partData.synchronization.length > 0 ? (this.selectTimeJ_children = true) : (this.selectTimeJ_children = false);
                        // 全职司机
                        this.fullData = res.data[1];
                        this.fullData.step_conf = JSON.parse(res.data[1].step_conf);
                        this.fullData.synchronization = JSON.parse(res.data[1].synchronization);
                        this.fullData.synchronization.length > 0 ? (this.selectTimeQ_children = true) : (this.selectTimeQ_children = false);
                        console.log(this.fullData.synchronization, '---------');

                        // 按单司机
                        this.singleData = res.data[2];
                        this.singleData.step_conf = JSON.parse(res.data[2].step_conf);
                        this.singleData.synchronization = JSON.parse(res.data[2].synchronization);
                        this.singleData.synchronization.length > 0
                            ? (this.selectTimeD_children = true)
                            : (this.selectTimeD_children = false);

                        // _this.childLoading = false;
                        // console.log('payModeList方法完成');
                        resolve();
                    })
                    .catch((err) => {});
            });
        },



        //获取订单模式
        async orderModeList() {
            return new Promise((resolve) => {
                //  离await最近的方法前面要加async
                // vue promise 等待另一个接口里面的递归方法执行完在resolve
                _this.allModeArr_children = []; // 订单模式数组
                _this.modeAll_children = []; // 订单模式编码
                // console.log('订单模式1');

                //  _this.getMode(resolve).then((res) =>{
                //     console.log(333);

                //     resolve();

                // });
                _this.getMode(resolve);
                // console.log('订单模式2');

                // resolve();

                // console.log('orderModeList方法完成');
            });
        },

        getMode(resolve) {
            _this
                .$post('/order/orderModeLists', _this.mode_options_data_children)
                .then((res) => {
                    for (let i = 0; i < res.data.length; i++) {
                        _this.allModeArr_children.push(res.data[i]);
                    }

                    if (_this.mode_options_data_children.page * _this.mode_options_data_children.limit < res.count) {
                        _this.mode_options_data_children.page += 1;
                        _this.getMode(resolve);
                    } else {
                        for (let j = 0; j < _this.allModeArr_children.length; j++) {
                            _this.modeAll_children.push(_this.allModeArr_children[j].order_mode.order_mode_code);

                            // console.log(_this.modeAll_children.length, '_this.modeAll_children长度------=======');
                        }
                        // for循环执行完在 resolve
                        // 把订单模式编码单独放一个数组里面
                        // for (let index = 0; index < _this.allModeArr_children.length; index++) {
                        //     _this.modeCodeArray.push(_this.allModeArr_children[index].order_mode.order_mode_code);
                        // }

                        resolve();

                        // console.log(_this.allModeArr_children.length, '_this.allModeArr_children.length--getMode走完');
                    }
                })
                .catch((err) => {});
        },
        //添加按钮 e='qz' 全职司机 e='jz' 兼职司机
        addContent(e, index) {
            if (e == 'qz') {
                var obj_full_synchronization_children = {
                    order_mode_code_array: [],
                    step_conf: [],
                    time_end: '',
                    time_start: ''
                };

                // 每点击一次在数组中加入一个对象
                _this.fullData.synchronization.push(obj_full_synchronization_children);
            } else if (e == 'jz') {
                var obj_part_synchronization_children = {
                    order_mode_code_array: [],
                    step_conf: [],
                    time_end: '',
                    time_start: ''
                };

                // 每点击一次在数组中加入一个对象
                _this.partData.synchronization.push(obj_part_synchronization_children);
            } else if (e == 'ad') {
                var obj_single_synchronization_children = {
                    order_mode_code_array: [],
                    step_conf: [],
                    time_end: '',
                    time_start: ''
                };

                // 每点击一次在数组中加入一个对象
                _this.singleData.synchronization.push(obj_single_synchronization_children);
                console.log(_this.singleData);
            } else if (e == 'full') {
                this.fullData.step_conf.push({
                    base_amount: '',
                    fee_money: '',
                    fee_rate: ''
                });
            } else if (e == 'part') {
                this.partData.step_conf.push({
                    base_amount: '',
                    fee_money: '',
                    fee_rate: ''
                });
            } else if (e == 'single') {
                this.singleData.step_conf.push({
                    base_amount: '',
                    fee_money: '',
                    fee_rate: ''
                });
            } else if (e == 'fullSync') {
                this.fullData.synchronization[index].step_conf.push({
                    base_amount: '',
                    fee_money: '',
                    fee_rate: ''
                });
            } else if (e == 'partSync') {
                this.partData.synchronization[index].step_conf.push({
                    base_amount: '',
                    fee_money: '',
                    fee_rate: ''
                });
            } else if (e == 'singleSync') {
                this.singleData.synchronization[index].step_conf.push({
                    base_amount: '',
                    fee_money: '',
                    fee_rate: ''
                });
            }
        },
        // 删除按钮
        delData(index, e, index2) {
            if (e == 'qz') {
                // 删除数组中对应index的数据
                _this.fullData.synchronization.splice(index, 1);
            } else if (e == 'jz') {
                // 删除数组中对应index的数据
                _this.partData.synchronization.splice(index, 1);
            } else if (e == 'ad') {
                // 删除数组中对应index的数据
                _this.singleData.synchronization.splice(index, 1);
            } else if (e == 'full') {
                // 删除数组中对应index的数据
                this.fullData.step_conf.splice(index, 1);
            } else if (e == 'part') {
                // 删除数组中对应index的数据
                this.partData.step_conf.splice(index, 1);
            } else if (e == 'single') {
                // 删除数组中对应index的数据
                this.singleData.step_conf.splice(index, 1);
            } else if (e == 'fullSync') {
                console.log(index, index2);
                console.log(this.fullData.synchronization);
                // 删除数组中对应index的数据
                this.fullData.synchronization[index2].step_conf.splice(index, 1);
            } else if (e == 'partSync') {
                // 删除数组中对应index的数据
                this.partData.synchronization[index2].step_conf.splice(index, 1);
            } else if (e == 'singleSync') {
                // 删除数组中对应index的数据
                this.singleData.synchronization[index2].step_conf.splice(index, 1);
            }
        },

        selectTimeChangeQ() {
            _this.selectTimeQ_children = !_this.selectTimeQ_children;
        },
        selectTimeChangeJ() {
            _this.selectTimeJ_children = !_this.selectTimeJ_children;
        },
        selectTimeChangeD() {
            _this.selectTimeD_children = !_this.selectTimeD_children;
        },

        // 提交

        onSubmitDig(e) {
            if (this.fullData.step_conf > 0) {
                for (var i = 0; i < this.fullData.step_conf.length; i++) {
                    if (
                        !reg.test(this.fullData.step_conf[i].base_amount) ||
                        this.fullData.step_conf[i].base_amount < 0 ||
                        !reg.test(this.fullData.step_conf[i].fee_money) ||
                        this.fullData.step_conf[i].fee_money < 0 ||
                        !reg.test(this.fullData.step_conf[i].fee_rate) ||
                        this.fullData.step_conf[i].fee_rate < 0
                    ) {
                        _this.$message.error('全职司机自定义金额应为大于等于0的数字');
                        return;
                    }
                }
            }

            if (this.partData.step_conf > 0) {
                for (var i = 0; i < this.partData.step_conf.length; i++) {
                    if (
                        !reg.test(this.partData.step_conf[i].base_amount) ||
                        this.partData.step_conf[i].base_amount < 0 ||
                        !reg.test(this.partData.step_conf[i].fee_money) ||
                        this.partData.step_conf[i].fee_money < 0 ||
                        !reg.test(this.partData.step_conf[i].fee_rate) ||
                        this.partData.step_conf[i].fee_rate < 0
                    ) {
                        _this.$message.error('全职司机自定义金额应为大于等于0的数字');
                        return;
                    }
                }
            }

            if (this.singleData.step_conf > 0) {
                for (var i = 0; i < this.singleData.step_conf.length; i++) {
                    if (
                        !reg.test(this.singleData.step_conf[i].base_amount) ||
                        this.singleData.step_conf[i].base_amount < 0 ||
                        !reg.test(this.singleData.step_conf[i].fee_money) ||
                        this.singleData.step_conf[i].fee_money < 0 ||
                        !reg.test(this.singleData.step_conf[i].fee_rate) ||
                        this.singleData.step_conf[i].fee_rate < 0
                    ) {
                        _this.$message.error('全职司机自定义金额应为大于等于0的数字');
                        return;
                    }
                }
            }


            var reg = /^[0-9]+.?[0-9]*$/;
            if (_this.selectTimeQ_children) {
                // 第一个开关打开 全职

                for (var i = 0; i < this.fullData.synchronization.length; i++) {
                    if(this.fullData.synchronization[i].step_conf.length>0){
                        for (var j = 0; j < this.fullData.synchronization[i].step_conf.length; j++) {
                            console.log(444);
                            console.log(this.fullData.synchronization[i]);
                            if (
                                !reg.test(this.fullData.synchronization[i].step_conf[j].base_amount) ||
                                this.fullData.synchronization[i].step_conf[j].base_amount < 0 ||
                                !reg.test(this.fullData.synchronization[i].step_conf[j].fee_money) ||
                                this.fullData.synchronization[i].step_conf[j].fee_money < 0 ||
                                !reg.test(this.fullData.synchronization[i].step_conf[j].fee_rate) ||
                                this.fullData.synchronization[i].step_conf[j].fee_rate < 0 ||
                                !reg.test(this.fullData.synchronization[i].time_start) ||
                                this.fullData.synchronization[i].time_start < 0 ||
                                !reg.test(this.fullData.synchronization[i].time_end) ||
                                this.fullData.synchronization[i].time_end < 0
                            ) {

                                _this.$message.error('全职司机抽成时间段内容应为大于等于0的数字');
                                return;
                            }
                        }
                    }
                }
            }
            console.log(222);
            if (_this.selectTimeJ_children) {
                // 第二个开关打开 兼职

                for (var i = 0; i < this.partData.synchronization.length; i++) {
                    if(this.partData.synchronization[i].step_conf.length>0){
                        for (var j = 0; j < this.partData.synchronization[i].step_conf.length; j++) {
                            if (
                                !reg.test(this.partData.synchronization[i].step_conf[j].base_amount) ||
                                this.partData.synchronization[i].step_conf[j].base_amount < 0 ||
                                !reg.test(this.partData.synchronization[i].step_conf[j].fee_money) ||
                                this.partData.synchronization[i].step_conf[j].fee_money < 0 ||
                                !reg.test(this.partData.synchronization[i].step_conf[j].fee_rate) ||
                                this.partData.synchronization[i].step_conf[j].fee_rate < 0 ||
                                !reg.test(this.partData.synchronization[i].time_start) ||
                                this.partData.synchronization[i].time_start < 0 ||
                                !reg.test(this.partData.synchronization[i].time_end) ||
                                this.partData.synchronization[i].time_end < 0
                            ) {
                                _this.$message.error('兼职司机抽成时间段内容应为大于等于0的数字');
                                return;
                            }
                        }
                    }
                }
            }

            if (_this.selectTimeD_children) {
                // 第三个开关打开 按单
                console.log(this.singleData.synchronization, '按单司机抽成时间段内容');
                for (var i = 0; i < this.singleData.synchronization.length; i++) {
                    if(this.singleData.synchronization[i].step_conf.length>0){
                        for (var j = 0; j < this.singleData.synchronization[i].step_conf.length; j++) {
                            console.log(this.singleData.synchronization[i].step_conf[j].base_amount, this.singleData.synchronization[i].step_conf[j].fee_money, this.singleData.synchronization[i].step_conf[j].fee_rate, this.singleData.synchronization[i].time_start, this.singleData.synchronization[i].time_end);
                            if (
                                !reg.test(this.singleData.synchronization[i].step_conf[j].base_amount) ||
                                this.singleData.synchronization[i].step_conf[j].base_amount < 0 ||
                                !reg.test(this.singleData.synchronization[i].step_conf[j].fee_money) ||
                                this.singleData.synchronization[i].step_conf[j].fee_money < 0 ||
                                !reg.test(this.singleData.synchronization[i].step_conf[j].fee_rate) ||
                                this.singleData.synchronization[i].step_conf[j].fee_rate < 0 ||
                                !reg.test(this.singleData.synchronization[i].time_start) ||
                                this.singleData.synchronization[i].time_start < 0 ||
                                !reg.test(this.singleData.synchronization[i].time_end) ||
                                this.singleData.synchronization[i].time_end < 0
                            ) {
                                _this.$message.error('按单司机抽成时间段内容应为大于等于0的数字');
                                return;
                            }
                        }
                    }
                }
            }

            //如果添加自定义时间段开关是关的，提交数据的时候，清空已经填写的值
            if (!_this.selectTimeQ_children) {
                _this.submit_data_children.full_synchronization = JSON.stringify([]);
            } else {
                // 将json格式数据转换成字符串格式赋值给要提交的对象
                _this.submit_data_children.full_synchronization = JSON.stringify(_this.fullData.synchronization);
            }

            //如果添加自定义时间段开关是关的，提交数据的时候，清空已经填写的值
            if (!_this.selectTimeJ_children) {
                _this.submit_data_children.part_synchronization = JSON.stringify([]);
            } else {
                // 将json格式数据转换成字符串格式赋值给要提交的对象
                _this.submit_data_children.part_synchronization = JSON.stringify(_this.partData.synchronization);
            }

            if (!_this.selectTimeD_children) {
                _this.submit_data_children.single_synchronization = JSON.stringify([]);
            } else {
                // 将json格式数据转换成字符串格式赋值给要提交的对象
                _this.submit_data_children.single_synchronization = JSON.stringify(_this.singleData.synchronization);
            }


            this.submit_data_children.full_step = JSON.stringify(this.fullData.step_conf);
            this.submit_data_children.part_step = JSON.stringify(this.partData.step_conf);
            this.submit_data_children.single_step = JSON.stringify(this.singleData.step_conf);

            _this.saveLoading = true;
            bus.$on('btnStatus', (val) => {
                _this.saveLoading = val;
                // 接收http.js if (rules !== {}) {}里面的bus.$emit('btnStatus', false)，验证不通过，取消按钮loading
            });

            _this.$post('/paymode/editpayModeThird', _this.submit_data_children).then((res) => {
                _this.saveLoading = false;

                _this.$message.success('保存成功');

                this.$emit('updateUseMode', '4',4);

                _this.payModeList();

            });
        }
    }
};
</script>

<style scoped>
.edit-btn {
    float: right;
}

.modeStyle {
    margin-top: 10px;
}

.modeStyle > div > div {
    margin-left: 30px;
    margin-top: 10px;
    max-width: 100%;
}

.second-main-wrap {
    display: flex;
    justify-content: space-around;
}

.title h2 {
    font-weight: 700;
    margin-bottom: 30px;
    margin-right: 10px;
    color: #000;
    font-size: 24px;
    display: inline-block;
}

.title span {
    font-size: 16px;
    color: #606266;
}

.btn1 {
    margin-left: 10px;
    margin-top: 10px;
    width: 130px;
}

.timeX {
    width: 150px;
    margin-left: 10px;
    /* margin-top: 10px; */
}

.full-driver {
    margin-top: 20px;
    margin-left: 70px;
    margin-right: 10px;
}

.use_mode-btn {
    margin-left: 20px;
    height: 30px;
}

.mode-head {
    display: flex;
    align-items: center;
    margin-top: 30px;
}

.mode-title {
    display: inline-block;
    margin-bottom: 20px;
}

.mode_submit-data {
    margin: 20px 0 30px;
    width: 32%;
}

.mode-name {
    width: 500px;
    margin: 20px auto 0;
}

.modea {
    display: flex;
    justify-content: space-between;
}

.line {
    background-color: #909399;
    width: 1px;
}

.sava-btn {
    margin: 0 auto;
    display: block;
    margin-top: 10px;
}

.input-item1 {
    max-width: 160px !important;
    width: 60% !important;
    box-sizing: content-box !important;
}

.input-item-active {
    padding-left: 10px;
}

.title-square {
    background-color: #409eff;
    display: inline-block;
    width: 10px;
    height: 30px;
    margin-right: 5px;
}

.title-a {
    margin-top: 15px;
    display: inline-block;
}

.box-content {
    background-color: #eee;
    padding: 10px;
    border-radius: 10px;
    margin-bottom: 20px;
    width: 100%;
    box-sizing: border-box;
}

.span-mode {
    display: inline-block;
    width: 110px;
    text-align: right;
}

.disTitle {
    display: flex;
    align-items: center;
    margin-top: 10px;
}

.btnTitle {
    display: flex;
    justify-content: space-between;
    margin-top: 15px;
}

.btnSelect {
    width: 50px;
    height: 40px;
    margin-bottom: 15px;
}
</style>
<style>
.modeStyle-contain .el-checkbox {
    width: 200px;
}
</style>